if (!customElements.get('vbb-reactive-grid-carousel')) {
  customElements.define('vbb-reactive-grid-carousel', class ReactiveGridCarousel extends HTMLElement {
    constructor() {
      super();
      this.handleVariantChange = this.handleVariantChange.bind(this);
    }

    handleVariantChange() {
      const newCarouselContentsSelector = `[data-template="carousel"][data-variant-id="${this.productForm.activeVariantId}"]`;
      const newCarouselContents = this.productForm?.querySelector(newCarouselContentsSelector);

      if (newCarouselContents?.innerHTML != null) {
        this.innerHTML = newCarouselContents.innerHTML;
      }
      this.resetSeeMoreButton();
    }

    resetSeeMoreButton() {
      this.carousel = this.querySelector('ul');
      let seeMoreButton = this.querySelector('button');

      // window.scrollTo({
      //   top: carousel.querySelector('li').offsetTop,
      //   behavior: 'smooth',
      // });

      if (!seeMoreButton) {
        return;
      }

      seeMoreButton.dataset.active = 'false';
      seeMoreButton.textContent = 'See more';
      if (!this.carousel.classList.contains('hide-overflow')) {
        this.carousel.classList.add('hide-overflow');
      }

      seeMoreButton.addEventListener('click', () => {
        if (seeMoreButton.dataset.active === 'false') {
          this.carousel.classList.remove('hide-overflow');
          seeMoreButton.dataset.active = 'true';
          seeMoreButton.textContent = 'See less';
          window.scrollTo({
            top: this.carousel.querySelector('li:nth-of-type(5)').offsetTop,
            behavior: 'smooth',
          });
        } else {
          this.carousel.classList.add('hide-overflow');
          seeMoreButton.dataset.active = 'false';
          seeMoreButton.textContent = 'See more';
          window.scrollTo({
            top: this.carousel.querySelector('li').offsetTop,
            behavior: 'smooth',
          });
        }
      });
    };

    connectedCallback() {
      if (!this.productForm) {
        this.productForm = this.closest('vbb-product-form-reactive');
        this.productForm.addEventListener('variant:changed', this.handleVariantChange);
      }
      this.resetSeeMoreButton();
    }
    disconnectedCallback() {
      if (this.productForm) {
        this.productForm.removeEventListener('variant:changed', this.handleVariantChange);
      }
    }
  });
}
